// Mirrors packages/api/src/utils/watchlistLimits.ts. The API is the authority —
// these exist so the UI can disable an action before the user hits a 400,
// never to replace the server-side check.
export const MAX_WATCHLISTS_PER_USER = 10;
export const MAX_HOLDINGS_PER_WATCHLIST = 50;
